<template>

    <div>

        <v-alert class="ml-5 mr-10" v-show="apiError" max-width="900" type="warning">{{ apiError }}</v-alert>

        <!-- CONTROL PANEL -->
        <v-card class="d-flex flex-row" max-width="1200">

            <v-card tile flat color="grey darken-2" class="pa-3 d-flex" style="border: 1px solid yellow">

                <v-card color="white" width="200" height="200" :style="enabledModel ? 'opacity: 1' : 'opacity: 0.5'">
                    <v-img max-height="200"
                           max-width="200"
                           width="200"
                           height="200"
                           contain
                           :src="cdnBaseUrl('img/tangocard-logo.png')"
                    ></v-img>
                </v-card>

                <div class="d-flex flex-column justify-space-between">
                    <v-card-text class="flex-grow-1">
                        <p>
                            We exist to help you drive results in your reward or incentive program.
                            We’re the expert on all things rewards with products that make sending gift cards,
                            prepaid cards, and donations easy for you. Focus on engaging your people,
                            we’ll provide the great reward experience.
                        </p>
                    </v-card-text>

                    <v-card-text>

                        <v-btn class="mt-2" v-show="partner" color="primary" @click="manageRewardsClicked">
                            Manage Rewards
                        </v-btn>

                        <v-btn class="mt-2"
                               :color="enabledModel ? 'white' : 'primary'"
                               :text="!!enabledModel"
                               @click="configureClicked">
                            Configure
                        </v-btn>

                        <v-btn v-show="partner"
                               class="mt-2"
                               :text="!!enabledModel"
                               :color="enabledModel ? 'white' : 'primary'"
                               @click="partnerEnabledChanged">
                            {{ enabledModel ? 'DISABLE' : 'ENABLE' }}
                        </v-btn>

                        <v-btn text class="mt-2" @click="viewCatalogClicked">
                            <v-icon left>mdi-information-outline</v-icon>
                            Tango catalog
                        </v-btn>

                    </v-card-text>
                </div>
            </v-card>

            <div class="d-flex">
                <v-card tile flat color="grey darken-2" min-width="300" class="align-top">
                    <v-card-text>

                        <stat-box-numerical v-for="(balance,index) in balances"
                                            class="mb-4"
                                            :key="index"
                                            :value="balance.balance_cents/100"
                                            :hint="balance.currency"
                                            :prefix-icon="getCurrencyPrefixIcon('USD')"
                        ></stat-box-numerical>

                    </v-card-text>

                </v-card>

                <div v-show="enabledModel" class="align-bottom" style="border-left: 5px solid green"/>
                <div v-show="!enabledModel" class="align-bottom" style="border-left: 5px solid red"/>
            </div>

        </v-card>

        <!-- DIALOGS -->
        <tango-card-catalog-dialog v-model="dialogModel"

        ></tango-card-catalog-dialog>

        <tango-card-configure-dialog @change="tangoCardConfigChanged"
                                     v-model="configureDialogModel"
                                     :partner="partner"
                                     :saving="saving"
                                     :active="enabledModel"
        ></tango-card-configure-dialog>

        <confirmation-dialog
            v-model="disableConfirmationModel"
            delete
            @selected="partnerDisabledConfirmation"
            confirm-button-text="I know what I am doing"
            headline="Disable Tango Card rewards?">
            If you disable Tango Card rewards your panelists can no longer see or request Tango Cards.
            In addition the system will no longer process Tango Card redemptions even if approved in the Redemption Approvals.
            You can later enable Tango Card rewards with a single click.
            Are you sure?
        </confirmation-dialog>

        <json v-if="false" :data="balances"/>

    </div>

</template>

<script>

import Store from '../../store';
import {mapActions, mapState} from 'vuex';
import TangoCardCatalogDialog from "./TangoCardCatalogDialog";
import TangoCardConfigureDialog from "./TangoCardConfigureDialog";
import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";
import Json from 'vue-json-pretty';
import {currencyMixin} from "../../../../components/mixins/currencyMixin";
import ConfirmationDialog from "../../../../components/UI/ConfirmationDialog";

const vuexModule = 'Rewards';

export default {

    mixins: [currencyMixin],

    components: {
        ConfirmationDialog,
        TangoCardCatalogDialog,
        TangoCardConfigureDialog,
        StatBoxNumerical,
        Json
    },

    data() {
        return {
            clientId: null,
            dialogModel: false,
            configureDialogModel: false,
            saving: false,
            disableConfirmationModel: false,
        }
    },

    computed: {
        ...mapState(vuexModule, [
            'partners'
        ]),

        enabledModel: {
            get() {
                return !!this.partners.find(partner => {
                    if (partner.type === 'TangoCard' && partner.enabled) {
                        return true;
                    }
                });
            },
            set(value) {
                value ? this.enablePartner(this.partner.id) : this.disablePartner(this.partner.id);
            }
        },

        partnerSettings() {
            const found = this.partners.find(partner => partner.type === 'TangoCard');
            if (found) return found.settings;
        },

        apiError() {
            if (this.partner && this.partner.error) {
                return this.partner.error;
            }
        },

        partner() {
            const found = this.partners.find(partner => partner.type === 'TangoCard');
            return found;
        },

        balances() {
            if (this.partner) {
                return this.partner.balances;
            }
            return [];
        },
    },

    methods: {

        ...mapActions(vuexModule, [
            'createPartnerSettings',
            'disablePartner',
            'enablePartner'
        ]),

        tangoCardConfigChanged(data) {
            this.saving = true;

            this.createPartnerSettings(data)
                .then((data) => {
                    if (data.settings.mode === 'sandbox') {

                        this.configureDialogModel = false;

                        Bus.$emit('flash-message', {
                            type: 'success',
                            duration: 15000,
                            message: 'Tango Card sandbox account with 1000 USD is now enabled!'
                        });

                    } else {
                        Bus.$emit('flash-message', {
                            type: 'success',
                            duration: 15000,
                            message: 'Tango Card production account created! Next please contact Tango Card to fund your account!'
                        });
                    }
                })
                .catch(error => {
                    Bus.$emit('flash-message', {type: 'error', message: error.response.data.message});
                })
                .finally(() => {
                    this.saving = false;
                })
        },

        partnerDisabledConfirmation(value) {
            if (value) {
                this.enabledModel = false;
                this.disablePartner(this.partner.id);
                Bus.$emit('flash-message', {type: 'warning', message: 'Tango Card rewards are now disabled!'});
            }
        },

        partnerEnabledChanged() {
            if (this.enabledModel) {
                this.disableConfirmationModel = true;
            } else {
                this.enabledModel = true;
                this.enablePartner(this.partner.id);
                Bus.$emit('flash-message', {type: 'success', message: 'Tango Card rewards are now enabled!'});
            }
        },

        viewCatalogClicked() {
            this.sendToUrl('https://www.rewardsgenius.com/reward-catalog/', true);
        },
        manageRewardsClicked() {
            this.dialogModel = true;
        },
        configureClicked() {
            this.configureDialogModel = true;
        }
    },

    created() {
        if (!this.$store.state[vuexModule]) {
            this.$store.registerModule(vuexModule, Store);
        }
    },
}
</script>
